export const formatIANATimezone = (timezone: string): string =>
  timezone.replaceAll('_', ' ');
